import React from 'react';

export default () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{
      width: '24px',
      height: '24px'
    }}
    fill='none'
    viewBox='0 0 24 24'
    stroke='currentColor'
    strokeWidth={1.5}
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5'
    />
  </svg>
);
